<template>
    <div class="input-group">
        <div class="input-group-btn">
            <ul role="menu" class="fancy_checkbox_list dropdown-menu">
                <li>
                    <input type="radio" checked ref="name-ref">
                    <label role="menuitem">
                        <span @click="searchByName()">Search by Name</span>
                    </label>
                </li>
                <li>
                    <input type="radio" ref="detail-ref">
                    <label role="menuitem">
                        <span @click="searchByDefinition()">Search by Details</span>
                    </label>
                </li>
            </ul>
            <button type="button"
                    class="btn btn-default dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
            >
                {{ searchType }}
                <span class="caret" />
            </button>
        </div>
        <!-- Need to prevent enter key from submitting the bulk action form-->
        <input type="text" class="form-control" v-model="searchText" @keypress.13.prevent placeholder="Type to search">
    </div>
</template>

<script>
export default {
    name: "Search",
    props: {
        initialSearchText: {
            type: String,
            required: true
        }
    },

    data: () => ({
        searchType: 'Search by Name',
        searchText: '',
        isWaiting: false
    }),

    watch: {
        searchText: function () {
            if (!this.isWaiting) {
                setTimeout(() => {
                    this.updateSearchText()
                    this.isWaiting = false
                }, 1000); // Delay by 1 second
            }
            this.isWaiting = true
        }
    },

    mounted() {
        this.searchText = this.initialSearchText
    },

    methods: {
        searchByName() {
            this.$refs["detail-ref"].checked = false
            this.$refs["name-ref"].checked = true
            this.searchType = 'Search by Name'
            this.searchText = ''
        },

        searchByDefinition() {
            this.$refs["detail-ref"].checked = true
            this.$refs["name-ref"].checked = false
            this.searchType = 'Search by Details'
            this.searchText = ''
        },

        updateSearchText() {
            if (this.$refs["detail-ref"].checked) {
                this.$emit('update-search', {
                    'searchOn': 'definition',
                    'searchText': this.searchText
                })
            } else if (this.$refs["name-ref"].checked) {
                this.$emit('update-search', {
                    'searchOn': 'name',
                    'searchText': this.searchText
                })
            }
            this.$emit('reset-pagination', 1)
        }
    }
}
</script>
